<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header d-none">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2 class="mb-2">Wake Up Call</h2>

                <!-- Text -->
                <p class="text-muted mb-md-0">This is Wake Up Call menu</p>
              </div>
              <div class="col-12 col-md-auto"></div>
            </div>
          </div>
        </div>
        <!-- Body -->
      </div>
    </div>
    <!-- / .header -->

    <!-- CARDS -->
    <div class="container-fluid mt-5">
      <!-- / .row -->
      <div class="row">
        <div class="col-12">
          <!-- Convertions -->
          <div class="card">
            <div class="card-header">
              <!-- Title -->
              <h4 class="card-header-title">Wake Up Call List</h4>

              <!-- Switch -->
              <div class="form-check form-switch">
                <button
                  class="btn btn-success"
                  v-b-modal.modal-form
                  @click="reset()"
                >
                  <i class="fe fe-plus"></i>
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="d-flex justify-content-end mb-3">
                <label class="align-self-center mb-0 mr-3">Search</label>
                <b-form-input
                  v-model="vgt_params.searchQuery"
                  class="w-auto"
                  placeholder="Type Here..."
                  @change="getList()"
                ></b-form-input>
              </div>
              <vue-good-table
                mode="remote"
                :line-numbers="true"
                :columns="columns"
                :rows="list.rows"
                :total-rows="list.totalRecords"
                :sort-options="{
                  enabled: true,
                }"
                :pagination-options="{
                  enabled: true,
                  perPage: vgt_params.perPage,
                }"
                @on-sort-change="onSortChange"
                @on-page-change="onPageChange"
                @on-per-page-change="onPageChange"
                :isLoading.sync="isLoading"
              >
                <div slot="emptystate" class="text-center font-size-14">
                  No data available
                </div>
                <template slot="table-row" slot-scope="props">
                  <div v-if="props.column.field == 'description'">
                    <span>{{props.row.description}}</span>
                  </div>
                  <div
                    v-else-if="props.column.field == 'source_path'"
                    class="text-center no-wrap"
                  >
                    <audio controls v-if="props.row.source_path" :key="props.row.source_path">
                      <source :src="props.row.source_path" type="audio/mpeg">
                      Your browser does not support the audio tag.
                    </audio>
                  </div>
                  <div
                    v-else-if="props.column.field == 'status'"
                    class="text-center no-wrap"
                  >
                    <span
                      class="badge bg-info"
                      v-if="props.row.status == 'CREATED'"
                      >Created</span
                    >
                    <span
                      class="badge bg-secondary"
                      v-else-if="props.row.status == 'SCHEDULED'"
                      >Scheduled</span
                    >
                    <span class="badge bg-success" v-else>Sent</span>
                  </div>
                  <div
                    v-else-if="props.column.field == 'action'"
                    class="text-center no-wrap"
                  >
                    <button class="btn btn-sm btn-warning mx-1" @click="updateData(props.row)" v-if="props.row.status != 'SENT'">
                      <span class="fe fe-edit"></span>
                    </button>
                    <button class="btn btn-sm btn-info mx-1" @click="viewData(props.row)">
                      <span class="fe fe-list"></span>
                    </button>
                    <button class="btn btn-sm btn-primary mx-1" @click="deleteData(props.row.id)" >
                      <span class="fe fe-trash-2"></span>
                    </button>
                  </div>
                </template>
                <template slot="pagination-bottom" slot-scope="props">
                  <div class="d-flex justify-content-end">
                    <div>
                      <b-pagination
                        :value="1"
                        :total-rows="list.totalRecords"
                        :per-page="vgt_params.perPage"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="m-3"
                        @input="
                          (value) => props.pageChanged({ currentPage: value })
                        "
                      ></b-pagination>
                    </div>
                  </div>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
      <!-- / .row -->
      <b-modal
        id="modal-form"
        title="Form Wake Up Call"
        size="xl"
        footer-class="p-3"
        ok-only
        centered
        scrollable
      >
        <validation-observer ref="wacRules">
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <div class="form-group mb-2">
                <validation-provider #default="{ errors }" name="Title" rules="required">
                  <label>Title <small class="text-danger">*</small></label>
                  <input type="text" v-model="modalForm.title" class="form-control" placeholder="Title" name="Title" :state="errors.length > 0 ? false : null" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
              <div class="form-group mb-2">
                <validation-provider #default="{ errors }" name="Description" rules="required">
                  <label>Description <small class="text-danger">*</small></label>
                  <textarea v-model="modalForm.description" class="form-control" placeholder="Description" name="Description" :state="errors.length > 0 ? false : null"></textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
              <div class="form-group mb-2">
                <validation-provider #default="{ errors }" name="Source Type" rules="required">
                  <label>Source Type <small class="text-danger">*</small></label>
                  <v-select v-model="modalForm.source_type" :options="source_type" :clearable="false" label="label" :reduce="(e) => e.id" :state="errors.length > 0 ? false : null" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
              <div class="form-group mb-2" v-if="modalForm.source_type == 'LINK'">
                <validation-provider #default="{ errors }" name="URL" rules="required|url">
                  <label>URL <small class="text-danger">*</small></label>
                  <input type="url" v-model="modalForm.source_path" class="form-control" placeholder="URL" name="URL" :state="errors.length > 0 ? false : null"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
              <div class="form-group mb-2" v-else>
                <validation-provider #default="{ errors }" name="Audio File" rules="required">
                  <label>Audio File <small class="text-danger">*</small></label>
                  <b-form-file v-model="modalForm.sound" :state="!Boolean(modalForm.sound) || errors.length > 0 ? false : null" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." accept=".mp3,.wav" ref="fileUpload" @change="fileUploader"></b-form-file>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
              <div class="form-group mb-2">
                <validation-provider #default="{ errors }" name="Scheduling Type" rules="required">
                  <label>Scheduling Type <small class="text-danger">*</small></label>
                  <v-select v-model="modalForm.scheduling" :options="scheduling" :clearable="false" label="label" :reduce="(e) => e.id" :selectable="e => e.selectable" :state="errors.length > 0 ? false : null"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
              <div class="form-group mb-2" v-if="modalForm.scheduling == 'SCHEDULED'">
                <validation-provider #default="{ errors }" name="Scheduled Datetime" rules="required">
                  <label>Scheduled Datetime <small class="text-danger">*</small></label>
                  <input type="datetime-local" v-model="modalForm.scheduling_datetime" class="form-control" placeholder="Datetime" name="Datetime" :state="errors.length > 0 ? false : null" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </div>
            <div class="col-lg-6 col-md-6">
              <div v-for="(x, i) in modalForm.target" :key="`mft${i}`">
                <div class="form-group mb-2">
                  <label>Target Type</label>
                  <v-select
                    v-model="x.type"
                    :options="target_type"
                    :clearable="false"
                    label="label"
                    :reduce="(e) => e.id"
                    disabled
                  />
                </div>
                <div class="form-group mb-2" v-if="x.type == 'PERSON'">
                  <label>User</label>
                  <v-select
                    v-model="x.targets"
                    :options="users"
                    label="fullname"
                    :reduce="(e) => e.keycloak_id"
                    multiple
                  />
                </div>
                <div class="form-group mb-2" v-else>
                  <label>Area</label>
                  <v-select
                    v-model="x.targets"
                    :options="locations"
                    label="location_name"
                    :reduce="(e) => e.id"
                    multiple
                  />
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
        <template #modal-footer>
          <div class="w-100">
            <button
              style="margin-left: auto; float: right"
              class="btn btn-primary"
              type="button"
              :disabled="formLoading"
              @click.prevent="formValidate()"
            >
              <b-spinner small v-if="formLoading"></b-spinner>
              Save
            </button>
          </div>
        </template>
      </b-modal>

      <b-modal
        id="modal-view"
        size="xl"
        hide-footer
        title="Detail Wake Up Call"
        centered
      >
        <div class="row">
          <div class="col-lg-4">
            <div class="form-group">
              <label>Title</label>
              <h3>{{ modal_view_data.title }}</h3>
            </div>
            <div class="form-group">
              <label>Description</label>
              <h3>{{ modal_view_data.description }}</h3>
            </div>
            <div class="form-group">
              <label>Status</label>
              <h3>{{ modal_view_data.status }}</h3>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="d-flex justify-content-end mb-3">
              <label class="align-self-center mb-0 mr-3">Search</label>
              <b-form-input
                v-model="vgt_detail_params.searchQuery"
                class="w-auto"
                placeholder="Type Here..."
                @change="listRecipients()"
              ></b-form-input>
            </div>
            <vue-good-table
              mode="remote"
              :line-numbers="true"
              :columns="recipient"
              :rows="recipients.rows"
              :total-rows="recipients.totalRecords"
              :sort-options="{
                enabled: true,
              }"
              :pagination-options="{
                enabled: true,
                perPage: vgt_detail_params.perPage,
              }"
              @on-sort-change="onSortChange"
              @on-page-change="onPageChange"
              @on-per-page-change="onPageChange"
              :isLoading.sync="isLoading2"
            >
              <div slot="emptystate" class="text-center font-size-14">
                No data available
              </div>
              <template slot="table-row" slot-scope="props">
                <div v-if="props.column.field == 'sent_at'">
                  <span>{{myDateFormat(props.row.sent_at)}}</span>
                </div>
                <div v-else-if="props.column.field == 'played_at'">
                  <span>{{myDateFormat(props.row.played_at)}}</span>
                </div>
                <div v-else-if="props.column.field == 'finished_at'">
                  <span>{{myDateFormat(props.row.finished_at)}}</span>
                </div>
                <div
                  v-else-if="props.column.field == 'action'"
                  class="text-center no-wrap"
                >
                  <span>test</span>
                </div>
              </template>
              <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-end">
                  <div>
                    <b-pagination
                      :value="1"
                      :total-rows="recipients.totalRecords"
                      :per-page="vgt_detail_params.perPage"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="m-3"
                      @input="
                        (value) => props.pageChanged({ currentPage: value })
                      "
                    ></b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
  <!-- / .main-content -->
</template>
<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "WakeUpCall",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    list() {
      return this.$store.getters["wake_up_call/list"];
    },
    detail() {
      return this.$store.getters["wake_up_call/detail"];
    },
    recipient() {
      return this.$store.getters["wake_up_call/recipient"];
    },
    recipients() {
      return this.$store.getters["wake_up_call/recipients"];
    },
    columns() {
      return this.$store.getters["wake_up_call/columns"];
    },
    source_type() {
      return this.$store.getters["wake_up_call/source_type"];
    },
    scheduling() {
      return this.$store.getters["wake_up_call/scheduling"];
    },
    target_type() {
      return this.$store.getters["wake_up_call/target_type"];
    },
    locations() {
      return this.$store.getters["location/list"];
    },
    users() {
      return this.$store.getters["user/list"];
    },
  },
  data() {
    return {
      vgt_params: {
        searchQuery: "",
        sort: "",
        page: 1,
        perPage: 10,
      },
      isLoading: true,
      modalForm: {
        id: null,
        title: '',
        description: '',
        source_type: 'LINK',
        source_path: '',
        company_id: '1',
        scheduling: 'NOW',
        scheduling_datetime: '',
        scheduling_from_date: '',
        scheduling_to_date: '',
        target: [{
          type: 'PERSON',
          targets: []
        }, {
          type: 'AREA',
          targets: []
        }],
        sound: null
      },
      formLoading: false,
      modal_view_data: {},
      vgt_detail_params: {
        id: "",
        searchQuery: "",
        sort: "",
        page: 1,
        perPage: 10,
      },
      isLoading2: true,
    };
  },
  mounted() {
    this.getList();
    this.getListLocation();
    this.getListUser();
  },
  methods: {
    // vgt
    getList() {
      this.isLoading = true
      this.$store.dispatch("wake_up_call/GET_LIST", this.vgt_params)
        .finally(() => {
          this.isLoading = false;
        });
    },
    // Pagination
    onPageChange(payload) {
      this.vgt_params.perPage = payload.currentPerPage;
      this.vgt_params.page = payload.currentPage;
      this.getList();
    },
    onSortChange(params) {
      let sort1 = params[0].field;
      let sort2 = params[0].type;
      this.vgt_params.sort = `${sort1},${sort2}`;
      this.getList();
    },
    onPageChange2(payload) {
      this.vgt_detail_params.perPage = payload.currentPerPage;
      this.vgt_detail_params.page = payload.currentPage;
      this.listRecipients();
    },
    onSortChange2(params) {
      let sort1 = params[0].field;
      let sort2 = params[0].type;
      this.vgt_detail_params.sort = `${sort1},${sort2}`;
      this.listRecipients();
    },
    // Modal Form
    reset() {
      this.modalForm = {
        id: null,
        title: '',
        description: '',
        source_type: 'LINK',
        source_path: '',
        company_id: '1',
        scheduling: 'NOW',
        scheduling_datetime: '',
        scheduling_from_date: '',
        scheduling_to_date: '',
        target: [{
          type: 'PERSON',
          targets: []
        }, {
          type: 'AREA',
          targets: []
        }],
        sound: null
      }
    },
    getListLocation() {
      this.$store.dispatch("location/GET_LIST", { pob: true })
    },
    getListUser() {
      this.$store.dispatch("user/GET_LIST", { pob: true })
    },
    async fileUploader(event) {
      this.modalForm.sound = event.target.files;
    },
    viewData(props) {
      this.$bvModal.show("modal-view");
      console.log('props', props);
      this.modal_view_data = props
      this.vgt_detail_params.id = props.id
      this.listRecipients()
    },
    listRecipients() {
      this.$store.dispatch("wake_up_call/GET_RECIPIENT", this.vgt_detail_params).finally(() => this.isLoading2 = false)
    },
    updateData(props) {
      this.$bvModal.show("modal-form");
      this.reset();
      this.modalForm.id = props.id;
      this.modalForm.title = props.title;
      this.modalForm.description = props.description;
      this.modalForm.source_type = props.source_type;
      this.modalForm.source_path = props.source_path;
      this.modalForm.company_id = props.company_id;
      this.modalForm.scheduling = props.scheduling;
      this.modalForm.scheduling_datetime = props.scheduling_datetime;
      this.modalForm.scheduling_from_date = props.scheduling_from_date;
      this.modalForm.scheduling_to_date = props.scheduling_to_date;

      // manipulate target value
      let targets = JSON.parse(JSON.stringify(this.modalForm.target))
      for (let i = 0; i < targets.length; i++) {
        const a = targets[i];
        
        let target = props.target.reduce((acc, obj) => {
          if (obj.target_type == a.type) {
            acc.push(obj.target_id);
          }
          return acc;
        }, []);

        a.targets = target
      }
      this.modalForm.target = targets
    },
    saveForm() {
      this.formLoading = true;

      // console.log('this.modalForm', this.modalForm);
      const targets = [];
      for (let i = 0; i < this.modalForm.target.length; i++) {
        const e = this.modalForm.target[i];

        if (e.targets.length) {
          // console.log('e.targets', e.targets);
          for (let j = 0; j < e.targets.length; j++) {
            const t = e.targets[j];

            targets.push({
              type: e.type,
              target_id: t,
            });
          }
        }
      }
      // console.log('targets', targets);

      const formData = new FormData();
      formData.append('id', this.modalForm.id);
      formData.append('title', this.modalForm.title);
      formData.append('description', this.modalForm.description);
      formData.append('source_type', this.modalForm.source_type);
      formData.append('source_path', this.modalForm.source_path);
      formData.append('company_id', this.modalForm.company_id);
      formData.append('scheduling', this.modalForm.scheduling);
      formData.append('scheduling_datetime', this.modalForm.scheduling_datetime);
      formData.append('scheduling_from_date', this.modalForm.scheduling_from_date);
      formData.append('scheduling_to_date', this.modalForm.scheduling_to_date);
      formData.append('target', JSON.stringify(targets));
      formData.append('sound', this.modalForm.sound);

      if (this.modalForm.id) {
        this.$swal('Warning', 'Update data', 'warning');
        this.formLoading = false;
      } else {
        this.$store
          .dispatch('wake_up_call/CREATE', formData)
          .then((resp) => {
            this.$swal({
              title: 'Saved',
              text: 'Wake Up Call has been created',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then((resp) => {
              setTimeout(() => {
                this.getList(); // Refresh the table data after 1 second delay
              }, 1000);
              this.$bvModal.hide('modal-form');
              // this.getList();
            });
          })
          .catch((resp) => {
            this.$swal('Error', 'Error while create data', 'error');
          })
          .finally(() => {
            this.formLoading = false;
            this.reset();
          });
      }
    },
    deleteData(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#AF0404",
        cancelButtonColor: "#414141",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("wake_up_call/DELETE", { id }).then((resp) => {
            this.$swal({
              title: "Saved",
              text: "Wake Up Call has been deleted",
              icon: "success",
              confirmButtonText: "OK",
            }).then((resp) => {
              // this.getList();
            });
          }).catch((err) => {
            this.$swal("Error", "Error while delete data", "error");
          }).finally(() => {
            this.getList();
          })
        }
      })
    },
    formValidate() {
      this.$refs.wacRules.validate().then((success) => {
        if (success) {
          this.saveForm();
        } else {
          console.log("invalid");
        }
      });
    },
    myDateFormat(n) {
      return moment(n).isValid() ? moment(n).format('DD MMM YYYY HH:mm:ss') : n
    }
  },
};
</script>